const activityName = (report) => (report.name ?? '').replace(/\//g, '-');

export const buildPdfFileName = (report, format, day, month, year) => {
  const activity = activityName(report);
  const stationName = report.station_name ?? '';

  if (format === 'Entidades') {
    return `${stationName}_relatorio_${activity}_${report.id}_${day}_${month}_${year}.pdf`;
  }
  if (format === 'Postos') {
    return `${stationName}_relatorio_${activity}_${day}_${month}_${year}.pdf`;
  }
  return `Total_relatorio_${activity}_${day}_${month}_${year}.pdf`;
};

export const buildExcelFileName = (report, format, day, month, year) => {
  const activity = activityName(report);
  const stationName = report.station_name ?? '';
  const identifier = format === 'Entidades' ? report.id : report.station;

  return `${stationName} relatorio_${activity}_${identifier}_${day}_${month}_${year}.xlsx`;
};
